// PostgreSQL integer(int4) 상한 — 재고/가격/기준 컬럼이 전부 int4라 이 값을 넘으면 UI는
// 통과해도 int4 변환(SQLSTATE 22003)에서 실패한다. (JS 자체 정수 정밀도 경계는 2^53−1로
// 별개 — 여기서 막는 건 DB 컬럼 상한이다.)
export const INT4_MAX = 2_147_483_647;

// strict 파싱(codexloop R1 Fix A) — 빈 문자열/음수/소수/NaN/int4 초과 전부 무효(null).
// 입력값과 저장값이 몰래 달라지는 조용한 보정(클램프·트렁크) 금지 — 무효 입력은 무효로
// 남겨 제출을 막는다. NewItemModal·RegisterUnmatchedItemDialog가 공유(복제 drift 방지,
// codexloop 등록다이얼로그 R1 수용).
export function parseNonNegativeInt(raw: string): number | null {
  if (raw.trim() === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || !Number.isInteger(n) || n < 0 || n > INT4_MAX) return null;
  return n;
}
